// extracted by mini-css-extract-plugin
export default {"container":"ChatMessages_container__nbi-p","animateIn":"ChatMessages_animateIn__HpIFY"};